import {Component, ElementRef, OnInit, Output, EventEmitter, Input, ViewChild} from '@angular/core';

import { Rule } from '../services/capd.model';
import { RulesService } from '../services/rules.service';
declare var $: any;

@Component({
  selector: 'rule-add',
  templateUrl: './rule-add.component.html',
  // inputs: ['rules']
})

/**
 * Component for adding new rule to the library of all rules.
 */
export class RuleAddComponent implements OnInit {
  @Output() listChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('modalAddRule', null) modalAddRule: ElementRef;
  elementRef: ElementRef;
  newRule = {
    triggerName: null,
    triggerCategory: null,
    triggerCode: null,
    sqlExpression: null,
    renderEnvironment: 'Default',
    action: { messageTitle: null, actionType: 'Message', messageText: '', messagePriority: 'Normal' }
  };
  categories: string[];
  @Input() rules: Rule[];
  // Text variables!
  catText = 'Create new category';
  advText = 'Show advanced';
  catErrorText: string;
  ruleErrorText: string;

  // We have so many booleans.
  catDropdown = true;
  ruleError = false;
  catError = false;
  codeError = false;
  advanced = false;

  // ElementRef is used to invoke jquery commands.
  constructor(private _service: RulesService, elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  /**
   * Gets existing categories and rules so we can check if there are duplicates later.
   *
   * @func ngOnInit
   */
  ngOnInit() {
    this.refreshRuleMetadata();
  }

  private refreshRuleMetadata() {
    return Promise.all([
      this._service.getCategories().then((categories: string[]) => this.categories = categories),
      this._service.getRules().then((rules: Rule[]) => this.rules = rules)
    ]);
  }

  /**
   * Simple toggle between selecting a category from a dropdown and writing in a new category.
   *
   * @func toggleCategoryAdd
   */
  toggleCategoryAdd() {
    this.catDropdown = !this.catDropdown;
    if (this.catDropdown) { this.catText = 'Create new category'; }
    else { this.catText = 'Select category'; }
  }

  /**
   * Simple toggle between entering a trigger code and entering a SQL query.
   *
   * @func toggleAdvanced
   */
  toggleAdvanced() {
    this.advanced = !this.advanced;
    if (this.advanced) { this.advText = 'Hide advanced'; }
    else { this.advText = 'Show advanced'; }
  }

  /**
   * Attempts to create the new rule given the parameters provided by the user.
   * Can error out for any number of reasons.
   *
   * @async
   * @func onSubmit
   */
  async onSubmit() {
    // Reset error messages
    this.ruleError = false;
    this.catError = false;
    this.codeError = false;
    if (this.newRule.triggerName){this.newRule.triggerName = this.newRule.triggerName.trim(); }
    if (this.newRule.triggerCode){this.newRule.triggerCode = this.newRule.triggerCode.trim(); }
    if (this.newRule.triggerCategory){this.newRule.triggerCategory = this.newRule.triggerCategory.trim(); }

    if (!this.newRule.triggerCategory || this.newRule.triggerCategory.length <= 0) {
      this.catErrorText = 'Category is required';
      this.catError = true;
    }
    if (!this.catDropdown) {
      // Check if added category exists
      if (this.categories.indexOf(this.newRule.triggerCategory) >= 0) {
        this.catErrorText = 'This category already exists';
        this.catError = true;
      }
    }
    // Now check if the rule exists
    if (!this.newRule.triggerName || this.newRule.triggerName.length <= 0) {
      this.ruleErrorText = 'Name is required';
      this.ruleError = true;
    }
    if (this.rules.filter(rule => this.newRule.triggerName === rule.triggerName).length > 0) {
      this.ruleErrorText = 'This rule already exists';
      this.ruleError = true;
    }
    if (!this.newRule.triggerCode || this.newRule.triggerCode.length <= 0) {
      this.codeError = true;
    }
    if (!this.catError && !this.ruleError && !this.codeError) {
      this.newRule.action.messageTitle = this.newRule.triggerName;
      const addedRule = await this._service.addRule(this.newRule);
      await this.refreshRuleMetadata();
      this.listChange.emit(addedRule);
      this.onCancel(false);
      $(this.elementRef.nativeElement).find('#modal-add-rule').modal('hide');
    }
  }

  /**
   * When the user cancels the action, reset all variables back to default and hide the modal.
   *
   * @func onCancel
   */
  onCancel(refreshRules = true) {
    if (refreshRules) {
      this.refreshRuleMetadata();
    }
    this.newRule = {
      triggerName: null,
      triggerCategory: null,
      triggerCode: null,
      sqlExpression: null,
      renderEnvironment: 'Default',
      action: { messageTitle: null, actionType: 'Message', messageText: '', messagePriority: 'Normal'}
    };
    this.catText = 'Create new category';
    this.catDropdown = true;
    this.advText = 'Show advanced';
    this.advanced = false;

    this.ruleError = false;
    this.catError = false;
    this.codeError = false;
  }
}
